import React from "react";
import "./styles/AboutUs.css"

export class AboutUs extends React.Component{
    render() {
        return(
            <div className="about-us"></div>
        )
    }
}